import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import MDXRenderer from 'gatsby-plugin-mdx/mdx-renderer'
import { useLocation } from '@reach/router'

const FAQsQuery = graphql`
  query FAQsQuery {
    allMdx(
      filter: {
        frontmatter: {
          question: { nin: [null, ""] }
        }
      }
      sort: {
        fields: frontmatter___order, order: ASC
      }
    ) {
      edges {
        node {
          frontmatter {
            section
            question
            slug
            tags
          }
          id
          body
        }
      }
    }
  }
`

function Tags( { tagList } ) {
  const getTagClasses = (tag) => {
    return "faqTag " + tag.replaceAll(' ', '-').toLowerCase();
  }

  return (
    <span className="faqTags">
      {tagList.map((tag, index) => (
        <span
          key={index}
          className={getTagClasses(tag)}
        >
          {tag}
        </span>
      ))}
    </span>
  );
}

function FAQ( { children, frontmatter, isFirst, ...props} ) {
  const currentLocation = useLocation();
  const [isOpen, setIsOpen] = React.useState(false);

  // If the hash/anchor portion of the URL is present, open that answer.
  // Otherwise, open the first entry.
  React.useEffect(() => {
    const slugToOpen = currentLocation.hash.slice(1);
    setIsOpen((isFirst && (slugToOpen === "")) || slugToOpen === frontmatter.slug);
  }, [currentLocation, frontmatter, isFirst]);

  return (
    <details id={frontmatter.slug} open={isOpen}>
      <summary>
        {frontmatter.question}
        <Tags tagList={frontmatter.tags} />
      </summary>
      <p className="productList">Applies to: <Tags tagList={frontmatter.tags} /></p>
      <MDXRenderer>{children}</MDXRenderer>
    </details>
  );
}

export function FAQs( { sectionName } ) {
  const data = useStaticQuery(FAQsQuery);

  return (
    <div>
      {data.allMdx.edges
        .filter((edge) => edge.node.frontmatter.section === sectionName)
        .map((edge, index) => (
          <FAQ
            key={index}
            frontmatter={edge.node.frontmatter}
            isFirst={(index === 0)}
          >
            {edge.node.body}
          </FAQ>
        ))
      }
    </div>
  );
}
